import axios from '@/plugins/axios'

export default {
  async MY_ORDERS ({ commit, state }, payload) {
    const data = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return new Promise((resolve, reject) => {
      axios.get('order?page=' + payload, data).then((response) => {
        commit('loadingFail')
        resolve(response)
      }).catch((error) => {
        commit('loadingFail')
        reject(error)
      })
    })
  },
  async SHOW_ORDER ({ commit, state }, payload) {
    const data = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return axios.get('order/' + payload, data).then((response) => {
      commit('loadingFail')
      return response
    })
  },
  async LASTS_ORDERS ({ commit, state }) {
    return new Promise((resolve, reject) => {
      const data = {
        headers: {
          Authorization: 'Bearer ' + state.access_token
        }
      }
      commit('loading')
      axios.get('order/lasts', data).then((response) => {
        commit('loadingFail')
        resolve(response)
      }).catch(error => {
        commit('loadingFail')
        reject(error)
      })
    })
  },
  async UPDATE_ORDER ({ commit, state }, payload) {
    const options = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return axios.put('order/' + payload.id, payload, options).then((response) => {
      commit('loadingFail')
      return response
    })
  },
  async CREATE_ORDER ({ commit, state }, payload) {
    const options = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return new Promise((resolve, reject) => {
      axios.post(`module/stores/${state.store.id}/orders`, payload, options).then((response) => {
        resolve(response)
        commit('loadingFail')
        return response
      }).catch((error) => {
        commit('loadingFail')
        reject(error)
      })
    })
  }
}
